import { formatCurrency } from './shared';

/**
 * Montos del checkout nuevo: sin centavos cuando el monto es redondo y con
 * centavos cuando los tiene ($17,25). formatCurrency(…, 'no-decimals') corta
 * los centavos (Math.trunc): con un cupón del 50% mostraba $17 y la pasarela
 * cobraba $17,25, y la transferencia pedía "el monto exacto" sin centavos.
 */
const checkoutMoney = (value: number): string => {
  const rounded = Math.round(value * 100) / 100;
  return formatCurrency(rounded, Number.isInteger(rounded) ? 'no-decimals' : 'with-decimals');
};

export default checkoutMoney;
